"use client";
import { contactData } from "@/data/contact-info.data";
import { backgroundGradientStyles } from "@/data/styles.data";
import useOutsideClick from "@/hooks/shared/useOutsideClick";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { FcInfo } from "react-icons/fc";
import { MdOutlineMessage } from "react-icons/md";

export default function CircularContactUs() {
  const [open, , setOpen] = useOutsideClick("circular-menu");

  // Positions for small circles relative to top-left
  const positions = [
    { x: -41, y: -12, ...contactData[1] }, // linkedin
    { x: 10, y: -50, ...contactData[0] }, // whatsapp
    { x: -48, y: -80, ...contactData[2] }, // facebook
    { x: 10, y: -115, ...contactData[3] }, // email
    { x: -100, y: -35, ...contactData[4] }, // booking
  ];

  return (
    <div
      id="circular-menu"
      className=" hidden  w-fit h-fit fixed right-8 z-30  bottom-4 md:flex items-start justify-start p-4"
    >
      {/* Main Circle */}
      <section
        className={`${open ? "" : "  custom-animate-bounce hover:animate-none"}`}
      >
        <section
          className={`size-20 flex justify-center items-center rounded-full `}
          style={backgroundGradientStyles}
        >
          <div
            onClick={() => setOpen((prev) => !prev)}
            className={` size-[90%]   bg-gradient-to-br from-primary/20  via-white to-white text-gray-700   rounded-full flex items-center justify-center cursor-pointer shadow-lg relative z-10 `}
          >
            <FcInfo className="  absolute -top-1 -right-[6px] " size={28} />
            <span className=" font-bold  ">
              <MdOutlineMessage size={34} />
            </span>
          </div>
        </section>
      </section>

      {/* Small circles */}
      {positions.map((pos, i) => (
        <Link
          key={i}
          href={pos.href}
          target="_blank"
          className={`  size-12   cursor-pointer hover:scale-110 rounded-full flex items-center border border-light-border bg-background justify-center absolute transition-all duration-300`}
          style={{
            top: open ? pos.y : 0,
            left: open ? pos.x : 0,
            opacity: open ? 1 : 0,
            transform: open
              ? "scale(1) translate(0,0)"
              : "scale(0.5) translate(0,0)",
          }}
        >
          <span className="text-white">
            <Image
              src={pos.src}
              alt={pos.title}
              width={pos.width}
              height={pos.height}
            />
          </span>
        </Link>
      ))}
    </div>
  );
}
